import { memo } from 'react';
import { Prompt } from 'react-router';
import { useFormDirtyFlag } from '@client/hooks/formik.hooks';

const defaultMessage = 'Are you sure you want to navigate away? You will lose any unsaved data.';

interface DirtyPromptProps {
  readonly message?: string;
}

export const DirtyPrompt = memo<DirtyPromptProps>(({ message = defaultMessage }) => {
  const isDirty = useFormDirtyFlag();

  return (
    <Prompt
      when={isDirty}
      message={message}
    />
  );
});
